export default "__VITE_ASSET__Dxkqr$wx__"